export const props = {
  props: {
    MuiButton: {
      disableElevation: true,
    },
    MuiTableContainer: {
      disableElevation: true,
    },
    MuiBox: {
      borderColor: '#dfdfdf',
      borderRadius: 4,
    },
    borderWidth: 1,
    buzzContainerWidth: 1252,
    buzzBorderRadius: 4,
  },
};
